import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import Status from '../status/Status';
import { initEventHub } from '../eventhub/EventHub';

var EventHub = /*#__PURE__*/function () {
  function EventHub(url, key, endpoint) {
    var isActive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    _classCallCheck(this, EventHub);

    _defineProperty(this, "isActive", false);

    _defineProperty(this, "_events", []);

    this._url = url;
    this._key = key;
    this._endpoint = endpoint;
    this.isActive = isActive;
  }

  _createClass(EventHub, [{
    key: "init",
    value: function init() {
      initEventHub({
        apiHost: "".concat(this._endpoint, "/v1"),
        apiKey: this._key
      });
      return new Status(this, true);
    }
  }, {
    key: "sendEvent",
    value: function sendEvent(data) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (typeof window.analytics !== 'undefined') {
          window.analytics.track(data.event, data.property);
          setTimeout(function () {
            resolve(new Status(_this, true));
          }, 100);
        }
      });
    }
  }, {
    key: "url",
    get: function get() {
      return this._url;
    },
    set: function set(value) {
      this._url = value;
    }
  }, {
    key: "key",
    get: function get() {
      return this._key;
    },
    set: function set(value) {
      this._key = value;
    }
  }, {
    key: "endpoint",
    get: function get() {
      return this._endpoint;
    },
    set: function set(value) {
      this._endpoint = value;
    }
  }, {
    key: "events",
    get: function get() {
      return this._events;
    },
    set: function set(value) {
      this._events = value;
    }
  }]);

  return EventHub;
}();

export { EventHub as default };